import { render, staticRenderFns } from "./WonderJy99.vue?vue&type=template&id=1280afb0"
import script from "./WonderJy99.vue?vue&type=script&lang=js"
export * from "./WonderJy99.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports